import { SUBSCRIPTION_STATUSES, SUBSCRIPTION_STORES } from '@steado/admin-contract/billing';
import { z } from 'zod';

export const BILLING_VIEWS = ['subscriptions', 'events'] as const;
export type BillingView = (typeof BILLING_VIEWS)[number];

/**
 * Two views over one screen, both driven from the URL: "every subscription in
 * a billing-issue state" and "every delivery for this user" are both links.
 */
export const billingSearchSchema = z.object({
  view: z.enum(BILLING_VIEWS).default('subscriptions').catch('subscriptions'),
  search: z.string().trim().min(1).max(120).optional().catch(undefined),
  status: z.enum(SUBSCRIPTION_STATUSES).optional().catch(undefined),
  store: z.enum(SUBSCRIPTION_STORES).optional().catch(undefined),
  entitlement: z.enum(['free', 'premium']).optional().catch(undefined),
  /** RevenueCat adds event types, so this stays a free string. */
  type: z.string().trim().min(1).max(64).optional().catch(undefined),
  userId: z.string().uuid().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  event: z.string().uuid().optional().catch(undefined),
});

export type BillingSearch = z.infer<typeof billingSearchSchema>;
